export const NPS_CLASSIFICATION = {
  detractor: 1,
  neutral: 2,
  promoter: 3
}
